import { LoadingSpinner, PlainButton, Tooltip } from "@jugl-web/ui-kit";
import { cx, useTranslations } from "@jugl-web/utils";
import { useRestApiProvider } from "@jugl-web/rest-api";
import { collapsedIconButtonClassName } from "@web-src/modules/client-support/pages/ClientSupportPage/consts";
import { useEntitySelectedProvider } from "@web-src/modules/entities/providers/EntityProvider/useEntitySelectedProvider";
import React from "react";
import {
  CRMStatus,
  CRMStatusPill,
} from "@web-src/modules/client-support/pages/ClientSupportPage/components/ManageAccountsDrawer/components/CRMStatusPill";
import { ReactComponent as RefreshIcon } from "./assets/refresh.svg";
import { ReactComponent as SetupIcon } from "./assets/setup.svg";

export const DomainForwardingCell: React.FC<{
  forwardingStatus: CRMStatus;
  onSetupClick: () => void;
}> = ({ forwardingStatus, onSetupClick }) => {
  const { t } = useTranslations();
  const { entityId } = useEntitySelectedProvider();
  const { integrationsApi } = useRestApiProvider();
  const [getEmailConfig, { isFetching: isEmailConfigFetching }] =
    integrationsApi.useLazyGetEmailConfigQuery();

  return (
    <div className="flex w-full items-center justify-between gap-2">
      <Tooltip
        renderTrigger={({ props, ref }) => (
          <div ref={ref} {...props} className="cursor-default">
            <CRMStatusPill status={forwardingStatus} size="sm" />
          </div>
        )}
      >
        {forwardingStatus === "verified"
          ? t({
              id: "client-support-page.refresh-auth-status-info",
              defaultMessage: "Refresh to check the latest status ℹ️",
            })
          : t({
              id: "client-support-page.forwarding-not-detected",
              defaultMessage:
                "We couldn't detect email forwarding to your Jugl Inbox email. Check your Domain provider settings and try again ℹ️",
            })}
      </Tooltip>
      <div className="flex items-center gap-3">
        {forwardingStatus !== "verified" && (
          <Tooltip
            renderTrigger={({ props, ref }) => (
              <PlainButton
                className={cx(collapsedIconButtonClassName, "h-8 w-8")}
                ref={ref}
                {...props}
                onClick={onSetupClick}
              >
                <SetupIcon className="h-4.5 w-4.5" />
              </PlainButton>
            )}
          >
            {t({
              id: "client-support-page.setup",
              defaultMessage: "Setup",
            })}
          </Tooltip>
        )}
        <Tooltip
          renderTrigger={({ props, ref }) => (
            <PlainButton
              className={cx(collapsedIconButtonClassName, "h-8 w-8")}
              ref={ref}
              {...props}
              onClick={() => getEmailConfig({ entityId })}
              disabled={isEmailConfigFetching}
            >
              {isEmailConfigFetching ? (
                <LoadingSpinner size="xs" color="grey" />
              ) : (
                <RefreshIcon className="h-3.5 w-3.5" />
              )}
            </PlainButton>
          )}
        >
          {t({
            id: "common.refresh",
            defaultMessage: "Refresh",
          })}
        </Tooltip>
      </div>
    </div>
  );
};
